import { useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Download, ExternalLink, FileText } from "lucide-react";
import { toast } from "sonner";

const fetchBlobUrl = async (file) => {
  const res = await axios.get(`${API}/files/${file.storage_path}`, { responseType: "blob" });
  return URL.createObjectURL(new Blob([res.data], { type: file.content_type || res.data.type }));
};

export function InvoiceFileLink({ file, testId = "mcf-invoice-file" }) {
  const [busy, setBusy] = useState(false);
  if (!file?.storage_path) return <span className="text-sm text-muted-foreground">No invoice uploaded</span>;

  const run = async (download) => {
    setBusy(true);
    try {
      const url = await fetchBlobUrl(file);
      const a = document.createElement("a");
      a.href = url;
      if (download) a.download = file.filename || "invoice";
      else a.target = "_blank";
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      toast.error("Could not load the invoice file");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={testId}>
      <FileText className="h-4 w-4 text-[#1F8F88]" />
      <span className="text-sm font-medium truncate max-w-[220px]" title={file.filename}>{file.filename || "Invoice"}</span>
      <Button size="sm" variant="outline" className="h-7" disabled={busy} onClick={() => run(false)} data-testid={`${testId}-view`}>
        <ExternalLink className="h-3.5 w-3.5 mr-1" /> View
      </Button>
      <Button size="sm" variant="outline" className="h-7" disabled={busy} onClick={() => run(true)} data-testid={`${testId}-download`}>
        <Download className="h-3.5 w-3.5 mr-1" /> Download
      </Button>
    </div>
  );
}
